const ELLIPSIS_SEPARATOR = '...'
const DEFAULT_CHARACTER_WIDTH = 14

export const useFormatTransmissionFilename = (
  ellipsis: HTMLDivElement,
  startEllipsis: HTMLSpanElement,
  endEllipsis: HTMLSpanElement
) => {
  const text = ellipsis.dataset.filename
  const containerWidth = ellipsis.offsetWidth
  const midpoint = Math.floor(containerWidth / 2)

  if (!text) return
  startEllipsis.textContent = text
  let index = 0

  if (ellipsis.scrollWidth > containerWidth) {
    let truncatedText = text.slice(index, 1)

    index++

    startEllipsis.textContent = truncatedText

    while (startEllipsis.scrollWidth + DEFAULT_CHARACTER_WIDTH < midpoint) {
      truncatedText += text.slice(index, index + 1)
      index++
      startEllipsis.textContent = truncatedText + ELLIPSIS_SEPARATOR
    }
    truncatedText = ''

    for (let i = text.length - 1; i >= 0; i--) {
      if (endEllipsis.scrollWidth > midpoint) break
      const char = text[i]

      truncatedText = char + truncatedText

      endEllipsis.textContent = truncatedText
    }
  }
}
